import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';


class View extends BaseView {

	events() {
		return {
			'click a': this._onClick
		};
	}

	_onClick(e) {
		const
			id = $(e.currentTarget).data('anchor').replace(/^#/, ''),
			$el = id && $(`[id="${id}"]`)
		;

		if (!$el || !$el.length) {
			return false;
		}

		e.preventDefault();

		$('body, html').animate({
			scrollTop: $el.offset().top
		}, 500);
	}

}

export default View;
